export enum EventTypesEnum {
    Arrival = 1,
    Departure = 2,
    Invalid = 3,
}
